import { DataService } from "./data.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Url } from "../common/url";

@Injectable({
  providedIn: "root",
})
export class QavisitnotacceptedpointsService extends DataService {
  constructor(http: HttpClient, private localHttp: HttpClient) {
    super("qavisitpoint", http);
  }

  url: string = Url.qavisitpoint;

  getAllResources(
    powertrainId?: string,
    skip: number = 0,
    limit: number = 100,
    dateFrom: Date = null,
    dateTo: Date = null,
    pointType: string = null,
    trainNo: string = null
  ) {
    let fields = `&filter[fields]=date&filter[fields]=timein&filter[fields]=timeout&filter[fields]=id`;

    let ptId =
      powertrainId && powertrainId != "null"
        ? "&filter[where][powercoachId]=" + powertrainId
        : "";
    let pType =
      pointType && pointType != "null"
        ? "&filter[where][pointType]=" + pointType
        : "";
    let tNo =
      trainNo && trainNo != "null" ? "&filter[where][trainno]=" + trainNo : "";

    let filterInclude = "&filter[order]=id DESC";
    let dateSearch =
      dateFrom && dateTo
        ? `&filter[where][date][between][0]=${dateFrom}&filter[where][date][between][1]=${dateTo}`
        : "";
    let fDate =
      dateFrom && !dateTo ? `&filter[where][date][gt]=${dateFrom}` : "";
    let tDate = dateTo && !dateFrom ? `&filter[where][date][lt]=${dateTo}` : "";
    let limit25 = `?filter[limit]=${limit}&filter[skip]=${skip}`;
    let limitGreaterThan25 = `?filter[limit]=${limit}&filter[skip]=${skip}&filter={"fields":${fields}}`;
    let filterLimit = limit <= 25 ? limit25 : limitGreaterThan25;

    return this.localHttp.get(
      this.url +
        filterLimit +
        filterInclude +
        ptId +
        fDate +
        tDate +
        dateSearch +
        pType +
        tNo
    );
  }

  getAllResourcesCount(
    powertrainId?: string,
    dateFrom: Date = null,
    dateTo: Date = null,
    pointType: string = null,
    trainNo: string = null
  ) {
    let ptId =
      powertrainId && powertrainId != "null"
        ? "&where[powercoachId]=" + powertrainId
        : "";

    let dateSearch =
      dateFrom && dateTo
        ? `&where[date][between][0]=${dateFrom}&where[date][between][1]=${dateTo}`
        : "";
    let fDate = dateFrom && !dateTo ? `&where[date][gt]=${dateFrom}` : "";
    let tDate = dateTo && !dateFrom ? `&where[date][lt]=${dateTo}` : "";

    let pType =
      pointType && pointType != "null"
        ? "&[where][pointType]=" + pointType
        : "";
    let tNo =
      trainNo && trainNo != "null" ? "&[where][trainno]=" + trainNo : "";

    return this.localHttp.get(
      `${this.url}/count?` + ptId + fDate + tDate + dateSearch + pType + tNo
    );
  }
}
